import { fromUnixTime, getHours } from 'date-fns';

import { DETECTION_FILTERS } from './detectionFilters';

const HOURS_IN_DAY = 24;

function matchesDetectionFilter(event, detectionFilter) {
  switch (detectionFilter) {
    case DETECTION_FILTERS.EXCLUDE_MISDETECTION:
      return event.detected && !event.misdetection;
    case DETECTION_FILTERS.PICKUP_ONLY:
      return event.pickup;
    case DETECTION_FILTERS.ALL:
      return event.detected;
    default:
      return false;
  }
}

// R 型のイベントは検出の開始時刻を from、RatSense の検出結果は timestamp で持つ。
function detectedAt(event) {
  return event.from ?? event.timestamp;
}

export function aggregateHourlyDetections(events, detectionFilter) {
  const hours = new Array(HOURS_IN_DAY).fill(0);
  if (!events) return hours;

  events
    .filter(event => matchesDetectionFilter(event, detectionFilter))
    .forEach((event) => {
      const hour = getHours(fromUnixTime(detectedAt(event)));
      hours[hour] += 1;
    });

  return hours;
}
